







































import { defineComponent, PropType } from '@nuxtjs/composition-api';

export type FeatureReview = {
  feature: string;
  percentage: number;
  ratingText: string;
};

export default defineComponent({
  name: 'Review',
  props: {
    reviewerName: {
      type: String,
      required: true,
      default: ''
    },
    score: {
      type: Number,
      required: true,
      default: 0,
      validator: (value) => value >= 0 && value <= 5
    },
    date: {
      type: String,
      required: true,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: true,
      default: ''
    },
    usefulCount: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0,
      required: false
    },
    featuresReviews: {
      type: Array as PropType<FeatureReview[]>,
      default: () => []
    }
  }
});
